(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", () => {
    const alertElements = Array.from(
      document.querySelectorAll(".element-alert")
    );

    if (alertElements.length === 0) return;

    alertElements.forEach((alertElement) => {
      const alertId = alertElement.getAttribute("data-alert-id");

      const alertHidden = localStorage.getItem(`alert_${alertId}_hidden`);

      if (!alertHidden || alertHidden !== "true") {
        alertElement.classList.remove("hide");
      }

      const alertClose = alertElement.querySelector(".js-alert-close");

      if (!alertClose || alertClose === null) return;

      alertClose.addEventListener("click", (e) => {
        localStorage.setItem(`alert_${alertId}_hidden`, "true");
        alertElement.classList.add("hide");
      });
    });
  });
})();
